import { cssVar, extendTheme } from '@chakra-ui/react'
import { colors, greens } from '@hb/shared'

const $arrowBg = cssVar('popper-arrow-bg')
export const chakraTheme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    body: "'Open Sans', sans-serif",
    heading: "'Hero-New', sans-serif",
  },
  components: {
    Tooltip: {
      baseStyle: {
        bg: 'green.500',
        [$arrowBg.variable]: 'colors.green.500',
        color: 'white',
      },
    },
    // Charting-UI sage checkboxes — matches Hamilton_EHR_Charting_UI_Mockup.html
    // (Patient education topics). The mockup's checked state is the sage accent
    // (#4a7c59) with a white check; hover deepens to the timer sage (#3a6b47).
    // Hardcoded here rather than via colorScheme="green" because green.500 is the
    // teal brand color, not the charting sage.
    Checkbox: {
      baseStyle: {
        control: {
          borderColor: '#cccccc',
          borderWidth: '1px',
          borderRadius: '4px',
          bg: 'white',
          _dark: {
            bg: 'gray.900',
          },
          _checked: {
            bg: 'sage.500',
            borderColor: greens.sage.hex,
            color: 'white',
            _hover: {
              bg: greens.darkSage.hex,
              borderColor: greens.darkSage.hex,
            },
          },
          _indeterminate: {
            bg: greens.sage.hex,
            borderColor: greens.sage.hex,
            color: 'white',
          },
        },
      },
      // Control-box dimensions per `size` prop. The Checkbox component passes
      // `size={tokens.checkboxSize}` (InputSize 'xs'/'sm' → 'sm', 'md' → 'md',
      // 'lg' → 'lg'), so these keys map back to the input size scale. `control`
      // sets the box; `icon` scales the check glyph to fit.
      sizes: {
        sm: {
          control: { boxSize: '14px' },
          icon: { fontSize: '0.5rem' },
        },
        md: {
          control: { boxSize: '16px' },
          icon: { fontSize: '0.625rem' },
        },
        lg: {
          control: { boxSize: '20px' },
          icon: { fontSize: '0.75rem' },
        },
      },
    },
  },
  colors: {
    gray: {
      // 900: '#1C1819',
      // 800: '#342D2F',
      // 700: '#524649',
      // 600: '#706165',
      // 500: '#8E7E82',
      // 400: '#AC9DA1',
      // 300: '#BEB1B5',
      // 200: '#D0C6C9',
      // 100: '#f5edf0',
      // 50: '#fffafc',
      900: '#111111',
      800: '#333333',
      700: '#555555',
      600: '#777777',
      500: '#888888',
      400: '#aaaaaa',
      300: '#cccccc',
      200: '#dedede',
      100: '#f0f0f0',
      50: '#fafafa',
    },
    green: {
      900: '#0f2422',
      800: '#1d4943',
      700: '#2b6e65',
      600: '#388f83',
      500: colors.green.hex,
      400: '#6fc3ba',
      300: '#93d2cc',
      200: '#b7e1dd',
      100: '#dbf0ee',
    },
    // Charting-UI sage scale — enables `colorScheme="sage"` on Chakra components (Button,
    // Badge, Checkbox, …). Anchor shades reference the authoritative chartingGreens palette
    // (spec Section 0.6.1); the in-between steps are interpolated for a smooth 50→900 ramp.
    // 500 is the workhorse sage accent, 600 its hover (timer sage), 800/900 the dark-forest
    // Authenticate colors.
    sage: {
      50: '#eef6f0',
      100: greens.lightSage.hex, // #e8f3ec
      200: greens.darkMint.hex, // #c8ddd0
      300: '#a8c3b2',
      400: '#6e9a7c',
      500: greens.sage.hex, // #4a7c59
      600: greens.darkSage.hex, // #3a6b47
      700: '#2c5c3a',
      800: greens.forestGreen.hex, // #1f4d2e
      900: greens.authenticateHover.hex, // #163d23
    },
  },
  styles: {
    global: {
      '.js-focus-visible :focus:not([data-focus-visible-added])': {
        outline: 'none',
        boxShadow: 'none',
        // boxShadow: '0px 2px 5px red',
      },
    },
  },
})
